import * as types from './actionTypes';
import { IDisplayBoardState } from '../../models/displayboardModel';
import * as _ from 'lodash';

const initialState = {} as IDisplayBoardState;
const displayBoardReducer = (state = initialState, action) => {
    let undefinedData;
    switch (action.type) {
        case types.SET_DISPLAY_ID_AND_GET_TOKENS_DATA_REQUEST:
            if (action.payload.confirmAction)
                state = {
                    ...state,
                    displayId: undefinedData,
                    theme: undefinedData,
                    tokensData: undefinedData,
                    alertToken: undefinedData,
                    alertTokensData: undefinedData
                }
            break;
        case types.SOCKET_INTIATE:
            state = {
                ...state,
                displayId: undefinedData,
                theme: undefinedData,
                tokensData: undefinedData,
                alertToken: undefinedData,
                alertTokensData: undefinedData
            }
            break;
        case types.SET_DISPLAY_ID_AND_GET_TOKENS_DATA_RESPONSE:
            const { displayBoardId, themeName, tokensData, differentialData, isLicenseActive, isDisplayBoardActive } = action.payload;

            state = {
                ...state,
                isLicenseActive: isLicenseActive,
                isDisplayBoardActive: isDisplayBoardActive
            }

            if (tokensData) {
                if (!_.isEqual(state.tokensData, tokensData)) {
                    state = {
                        ...state,
                        displayId: displayBoardId,
                        theme: themeName,
                        tokensData: tokensData
                    }
                    if (differentialData.length > 0) {
                        let alertTokens = state?.alertTokensData ? state.alertTokensData : [];
                        state = {
                            ...state,
                            alertTokensData: [...alertTokens, ...differentialData]
                        }
                    }
                }
                else if (state.theme !== themeName) {
                    state = {
                        ...state,
                        theme: themeName
                    }
                }
            }
            else
                state = {
                    ...state,
                    displayId: displayBoardId,
                    theme: themeName,
                    tokensData: undefinedData,
                    alertToken: undefinedData,
                    alertTokensData: []
                }
            break;
        case types.ALERT_SUSPEND:
            state = {
                ...state,
                alertToken: undefinedData
            }
            break;

        case types.SET_ALERT:
            let alertTokenData = state.alertTokensData;
            if (alertTokenData?.length > 0) {
                let tokenData = alertTokenData.shift();

                state = {
                    ...state,
                    alertToken: tokenData,
                    alertTokensData: alertTokenData
                }
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default displayBoardReducer;